import { render, staticRenderFns } from "./TopForests.vue?vue&type=template&id=eb1e960e&scoped=true"
import script from "./TopForests.vue?vue&type=script&lang=js"
export * from "./TopForests.vue?vue&type=script&lang=js"
import style0 from "./TopForests.vue?vue&type=style&index=0&id=eb1e960e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1e960e",
  null
  
)

export default component.exports